import Immutable from "immutable";
import { mapArrayToEntity } from "lib/data";

import * as schoolLinked from "lib/appserver/entityHeaders/schoolLinked";

const Term = new Immutable.Record({
  ...schoolLinked.defaultProperties,
  name: undefined,
  startDate: undefined,
  endDate: undefined,
  breakStartDate: undefined,
  breakEndDate: undefined
}, "Term");
export default Term;

Term.fromAppserver = function buildTerm(rawTerm) {
  return Term({
    name: rawTerm.name,
    startDate: rawTerm.start_date,
    endDate: rawTerm.end_date,
    breakStartDate: rawTerm.break_start_date,
    breakEndDate: rawTerm.break_end_date,
    ...schoolLinked.appserverAdapter(rawTerm)
  });
}

Term.fromAppserverValueList = function buildTerm(valueList) {
  const rawTerm = mapArrayToEntity([
    "appserver_server_hostname",
    "appserver_server_id",
    "appserver_remote_school_id",
    "appserver_remote_entity_id",
    "id",
    "name",
    "start_date",
    "end_date",
    "break_start_date",
    "break_end_date"
  ], valueList);
  return Term.fromAppserver(rawTerm);
}



// WEBPACK FOOTER //
// ./src/state/teachers/entities/Term.js